<template lang="pug">
InheritWrapper(v-model="inherit" :readonly="innerSetting.ReadOnly || disabled")
  BriqMultiselect(
    :label="innerSetting.DisplayName"
    :help="innerSetting.Description"
    v-model="innerValue"
    :readonly="innerSetting.ReadOnly"
    track-by="Value"
    display="Name"
    :options="options"
    :error="fieldError"
    :disabled="innerSetting.ReadOnly || disabled ? true : inherit"
    :hideOptionalMarker="true"
    :required="this.$attrs.required"
  )
</template>

<script>
import InheritWrapper from '@v/settings/application/advanced/InheritWrapper.vue'
import setupInheritedField from './setupInheritedField.js'
import { computed, toRefs } from '@vue/composition-api'
import mixin from '@v/settings/application/advanced/mixin.js'
import { required } from 'vuelidate/lib/validators'

export default {
  components: { InheritWrapper },
  props: {
    setting: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  validations() {
    return {
      innerValue: {
        required,
        $each: {
          required,
        },
      },
    }
  },
  mixins: [mixin],
  setup: (props, { emit }) => {
    const fields = setupInheritedField({ props, emit })
    const options = computed(() => fields.innerSetting.ValueOptions)
    return { ...toRefs(fields), options }
  },
}
</script>
